import SliderBase from './base-slider';

class StblogSliderHandler extends SliderBase {

}

export default ( $scope ) => {
	elementorFrontend.elementsHandler.addHandler( StblogSliderHandler, { $element: $scope } );
};
